<template>
<b-col>
  <b-row>
    <EasyDataTable
      :headers="fields"
      :items="items"
      :alternating="true"
      :rows-per-page="10000"
      :hide-rows-per-page="true"
    >
      <template #item-buttons="item">
        <div style="text-align: right;">
          <b-button
            @click.stop="$emit('onEditCustomTestMethod', item)"
            size="sm"
            class="fa fa-edit"
          />
          <b-button
            @click.stop="$emit('onDeleteCustomTestMethod', item)"
            size="sm"
            class="fa fa-trash"
            variant="danger"
          />
        </div>
      </template>
    </EasyDataTable>
  </b-row>
</b-col>
</template>

<script>
export default {
  name: 'test-builder-table',
  computed: {
    fields() {
      return [
        { value: 'name', text: this.$t('name') },
        { value: 'buttons', text: ' ' }
      ]
    },
    items() {
      return this.customTestMethods || []
    }
  },
  props: ['customTestMethods']
}
</script>
